var BasePolyResizeMixin = require('./base'),
    LockAngleCalcPosition = require('draw-lock-angle').calculatePosition;


module.exports = {

    resizeStart: function( x, y, e ) {

        if ( !BasePolyResizeMixin.resizeStart.apply( this, arguments ) )
            return false;

        this.lineBasePt = _.without( this.currentPts, this.dragPoint )[0];
        this.lineBasePt['ox'] = this.lineBasePt.x;
        this.lineBasePt['oy'] = this.lineBasePt.y;

        // TODO: should have a mousemove that goes over the canvas in the base fns ... (or don't stop it)
        var canvasContainerRel = this.channel.request('canvasContainerRel');

        this.lockAngleBoundary = {
            minX: canvasContainerRel.x,
            minY: canvasContainerRel.y,
            maxX: canvasContainerRel.x2,
            maxY: canvasContainerRel.y2
        };

        return true;

    },
    /*
    * TODO: if the shift key is down and drawing straight line,
    *  may not want to return false if 'out of bounds' ...
    * */
    resizeMove: BasePolyResizeMixin.resizeMove,

    updatePath: BasePolyResizeMixin.updatePath,

    updateDragPtHandleAndPathOnMove: function( dx, dy, x, y, e ) {

        if ( !e.shiftKey ) {

            BasePolyResizeMixin.updateDragPtHandleAndPathOnMove.apply( this, arguments );

        } else {

            /*
            * In libraray example, 'newPoint' is the one from the 'origin' (here, the mouse posiition),
            * and last is the 'last one' placed down.
            * So we want the coordinates of the initial placement and the one you're dragging to.
            * */
            var projection = LockAngleCalcPosition(
                {
                    x: e.offsetX,
                    y: e.offsetY
                },
                { x: this.lineBasePt.ox, y: this.lineBasePt.oy },
                {
                    boundary: this.lockAngleBoundary
                }
            );

            _.extend( this.dragPoint, {
                x: projection.x,
                y: projection.y
            });

            /* also update the position of the drag handle based on the change in the size of the line */
            var cx = this.dragHandle.attr('cx'),
                cy = this.dragHandle.attr('cy');

            this.dragHandle.attr( {
                cx: cx + ( projection.x - cx ),
                cy: cy + ( projection.y - cy )
            });

            this.updatePath.apply( this, [e] );

        }

        return true;

    },

    resizeEnd: function() {

        if ( !BasePolyResizeMixin.resizeEnd.apply( this, arguments ) )
            return false;

        delete this.lineBasePt;
        delete this.lockAngleBoundary;

        return true;

    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/poly/line.js
 ** module id = 202
 ** module chunks = 0
 **/